module.exports = __webpack_public_path__ + "img/gallery-v3.0f8fb981.jpg";